export const IsNumberValidator = ({ getFieldValue }: any) => ({
  validator(_: any, value: any) {
    if (/^\d+$/.test(value) === true && value < 45) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('Provide valid integer <= 45.'));
  },
});
export const IsAnyNumberValidator = ({ getFieldValue }: any) => ({
  validator(_: any, value: any) {
    if (!value || !value.length) {
      return Promise.resolve();
    }
    if (/^\d+$/.test(value) === true) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('Provide valid integer.'));
  },
});

export const StartDateValidator = ({ getFieldValue }: any) => ({
  validator(_: any, value: any) {
    const today = new Date();
    const start_date = new Date(getFieldValue('start_date'));
    const Difference_In_Time = today.getTime() - start_date.getTime();
    const Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
    if (Difference_In_Days >= 0) {
      return Promise.resolve();
    }
    return Promise.reject(
      new Error(`Start date can't be lower than present date.`)
    );
  },
});

export const EndDateValidator = ({ getFieldValue }: any) => ({
  validator(_: any, value: any) {
    const input = new Date(value);
    const start_date = new Date(getFieldValue('start_date'));
    const Difference_In_Time = input.getTime() - start_date.getTime();
    const Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
    if (
      !getFieldValue('start_date') ||
      !getFieldValue('end_date') ||
      getFieldValue('present')?.target?.checked ||
      Difference_In_Days >= 0
    ) {
      return Promise.resolve();
    }
    return Promise.reject(
      new Error(`End date can't be lower than start date.`)
    );
  },
});

export const TextLengthValidator = ({ getFieldValue }: any) => ({
  validator(_: any, value: any) {
    if (!value || value.length <= 2000) {
      return Promise.resolve();
    }
    return Promise.reject(
      new Error('Ensure the value has at most 2000 characters.')
    );
  },
});
